const IconLongArrowRight = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="31.5"
			height="15.484"
			viewBox="0 0 31.5 15.484"
		>
			<path
				d="M22.074,15.188H.844A.844.844,0,0,0,0,16.031v3.938a.844.844,0,0,0,.844.844h21.23v3.239a1.688,1.688,0,0,0,2.881,1.193l6.051-6.051a1.687,1.687,0,0,0,0-2.386l-6.051-6.051a1.688,1.688,0,0,0-2.881,1.193Z"
				transform="translate(0 -10.258)"
				fill="#fff"
			/>
		</svg>
	)
}

export default IconLongArrowRight